export const hsaSiteConfig: any = {
  id: 'hsa',
  name: 'Sanatorio Aliare',
  institutionName: 'SANATORIO ALIARE',
  branding: {
    logo: 'assets/hsa/logo.svg',
    favicon: 'assets/images/logos/favicon.png',
  },
  social: {
    facebook: 'https://www.facebook.com/sanatorio.aliare/?locale=es_LA',
    instagram: 'https://www.instagram.com/sanatorio.aliare/?hl=es',
    youtube: 'https://www.youtube.com/@sanatorioaliare',
  },
  contact: {
    address: 'Italia 1428<br />Rosario - Santa Fe<br />Argentina',
    address_mobile: 'Italia 1428, Rosario, Santa Fe',
    phone: '',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Italia+1440%2C+Rosario%2C+Santa+Fe',
  },
  navigation: {
    portalPacienteUrl: '',
    services: [
      {
        label: 'Anastomía Patológica',
        url: 'https://www.sanatorioaliare.com/servicios/anatomia-patologica/',
      },
      {
        label: 'Anestesiología',
        url: 'https://www.sanatorioaliare.com/cuerpo-profesional/anestesiologia-2/',
      },
      { label: 'Ecografías', url: 'https://www.sanatorioaliare.com/ecografia/' },
      {
        label: 'Guardias 24 hs.',
        url: 'https://www.sanatorioaliare.com/servicios/guardias-las-24-hs/',
      },
      { label: 'Hemodinamia', url: 'https://www.sanatorioaliare.com/hemodinamia/' },
      { label: 'Hemoterapia', url: 'https://www.sanatorioaliare.com/hemodinamia/' },
      {
        label: 'Hospital de Día',
        url: 'https://www.sanatorioaliare.com/servicios/hospital-de-dia/',
      },
      {
        label: 'Laboratorio Bioquímico',
        url: 'https://www.sanatorioaliare.com/servicios/laboratorio-y-analisis/',
      },
      { label: 'Obesidad', url: 'https://www.sanatorioaliare.com/cuerpo-profesional/obesidad/' },
      { label: 'Radiología', url: 'https://www.sanatorioaliare.com/radiologia/' },
      { label: 'Tomografía', url: 'https://www.sanatorioaliare.com/tomografia/' },
    ],
    institutionMenuLabel: 'SANATORIO ALIARE',
    institucion: [
      { label: 'Ubicación', url: 'https://www.sanatorioaliare.com/ubicacion/' },
      { label: 'Institucional', url: 'https://www.sanatorioaliare.com/institucional/' },
      {
        label: '¿Querés trabajar en la RED AMR?',
        url: 'https://www.amr.org.ar/cargatucv/#/login/',
      },
    ],
    cuerpoProfesionalUrl: 'https://www.sanatorioaliare.com/profesionales/consultorios-aliare',
  },
  legal: {
    terms: {
      title: { prefix: 'Términos y', highlight: 'Condiciones' },
      content: `El objetivo de este documento es informar al usuario sobre las condiciones y normas de uso de
los sitios web de Kozaca S.A., Health Suite Aliare: Portal de Turnos
https://turnos.sanatorioaliare.com/ y Portal Paciente Mi Aliare
https://www.pacientes.sanatorioaliare.com y la homónima aplicación para teléfonos inteligentes
(de aquí en más HSA), el cual proporciona un servicio para que las personas puedan acceder a
información de salud y la gestionen. Funcionamiento de la aplicación: Mi Aliare es una
aplicación que puede ser instalada en el teléfono inteligente mediante las aplicaciones de las
tiendas de aplicaciones (iOS, Android.) identificada como Portal Paciente Mi Aliare. En Mi
Aliare las personas, luego de registrarse y confirmarse su registración podrán buscar y
reservar un turno con el profesional elegido, guardar y visualizar sus resultados de estudios
médicos y gestionar su salud. Con el solo uso del sitio web Usted está aceptando y prestando
su conformidad a todos los Términos y Condiciones de uso de HSA que se expresan en este
documento. La falta de aceptación del presente documento, generará que el Usuario deba
abstenerse de utilizar el sitio web y los servicios ofrecidos. El titular del sitio web tiene
el derecho de revisar y modificar estos Términos y Condiciones en cualquier momento sin
obligación de efectuar notificación alguna cuando esto suceda, por lo que usted debe revisar
estas normas cada vez que ingrese a los mismos, entendiéndose que ante cada ingreso que
realice al sitio está brindando su aceptación a cualquier modificación que eventualmente se
haya realizado a estos Términos y Condiciones. Los términos “Usted” y “Usuario” se emplean
para referirse a todas las personas físicas o jurídicas que accedan a los sitios web. 1-
Información General HSA no intenta ser un sustituto de asesoramiento en salud. Los Usuarios
siempre deben consultar a un proveedor o profesional de servicios de salud calificado y con
matrícula ante cualquier pregunta relacionada con algún síntoma. Nunca ignore los consejos
médicos, ni demore la búsqueda de una evaluación o tratamiento debido a algo que haya leído o
visto en los sitios web. En HSA no se hacen diagnósticos, tratamientos, consultas médicas, ni
recomendaciones. Kozaca S.A. Se reserva el derecho de admisión de usuarios a la plataforma.
Los usuarios que envíen preguntas en las páginas web deben tener en cuenta que las mismas
pueden publicarse en la plataforma. Al enviar contenido, cualquiera fuera su índole, los
usuarios dan su consentimiento para publicar el contenido enviado en la plataforma y/o en
redes sociales con fines de difusión y/o comerciales y sin derecho a originar indemnización
y/o compensación alguna por el eventual uso de ese contenido. Los usuarios que se comuniquen
con un miembro o institución de HSA a través del sistema de correo electrónico y que acepten
suscribirse a nuestro boletín informativo, recibirán actualizaciones ocasionales por correo
electrónico sobre recursos útiles relacionados con la salud y el asesoramiento. Se respetará
la privacidad del Usuario y la información de contacto o identificación (dirección de correo
electrónico, nombre, etc.). 2- Conducta del usuario El usuario deberá usar el sitio web sólo
para los fines mencionados. El usuario no debe publicar o transmitir a través de los sitios
web de Kozaca S.A. cualquier material que viole o infrinja los derechos de los demás, que sea
ilegal, amenazante, abusivo, difamatorio, invasivo de la privacidad o de los derechos de
publicidad, vulgar, obsceno, profano u objetable. No se permitirá ninguna conducta de un
Usuario que, a sola discreción de Kozaca S.A., restrinja o inhiba a cualquier Usuario. El
usuario no deberá utilizar este Sitio Web para publicitar o realizar ninguna solicitud
comercial, lo que incluye, entre otros, la solicitud de usuarios para convertirse en usuarios
de otros servicios de información en línea competitivos con Kozaca S.A. HSA contiene material
con derechos de autor, marcas comerciales y otra información de propiedad, incluidos, entre
otros, texto, fotos, videos, gráficos y sonido. Todo el contenido está protegido por la
legislación sobre propiedad industrial e intelectual (Derechos de Autor, copyright, marcas
registradas). Todo el Contenido es propiedad de Kozaca S.A., así como de sus proveedores de
contenido o de sus clientes, y está protegida por la legislación sobre propiedad industrial e
intelectual de Argentina. El uso no autorizado del Contenido puede implicar la violación de la
legislación sobre propiedad intelectual o industrial. El usuario no puede modificar, publicar,
transmitir, participar en la transferencia o venta, crear trabajos derivados, o de ninguna
manera explotar cualquiera de los contenidos. El usuario puede descargar material protegido
por derechos de autor para uso personal del Usuario siempre que se incluya el siguiente aviso
en dichos materiales: "Derechos de autor: KOZACA. Queda prohibida, salvo autorización previa,
expresa y por escrito, la transmisión, cesión, venta, alquiler y/o exposición pública de esta
web, cualquier parte de la misma o de su contenido, el incumplimiento de este punto o
cualquier otro de los presentes términos, lo hará pasible de las acciones judiciales
correspondientes”. El usuario no deberá cargar, publicar o poner a disposición en los sitios
web/app de Kozaca S.A. ningún material protegido por derechos de autor, marca registrada u
otro derecho de propiedad sin el permiso expreso del propietario del derecho de autor, marca
registrada u otro derecho de propiedad. El usuario será el único responsable de cualquier daño
resultante de cualquier infracción de los derechos de autor, derechos de propiedad o cualquier
otro daño resultante de dicha presentación. El usuario también permite que cualquier otro
Usuario acceda, vea, almacene o reproduzca el material para uso personal. El usuario otorga a
KOZACA el derecho de editar, copiar, publicar y distribuir cualquier material disponible en
HSA por el Usuario. El usuario se hace responsable de sus propias publicaciones y acepta no
realizar ninguna de las siguientes acciones dentro de los sitios web: • Publicar contenido que
infrinja los derechos de propiedad intelectual o industrial de terceros, o los derechos de
confidencialidad o imagen de terceros; • Publicar contenido que sea obsceno, amenazador,
acosador, o denigrante hacia otro Usuario o Visitante, o hacia cualquier persona o entidad; •
Publicar una imagen o declaración sexualmente explícita; anunciar propaganda o propuestas de
negocio • Enviar material que contenga virus u otras rutinas de programación que tengan por
objeto dañar, interferir negativamente, interceptar secretamente, o apropiarse de cualquier
sistema, datos o información. • Publicar contenido que infrinja la normativa relacionada a la
protección de datos personales y/o de la confidencialidad de la información sanitaria y en
especial que infrinja lo dispuesto en las leyes nros 26.529 y 25.326. • Anunciar datos
personales y profesionales incompletos, falsos o inexactos o datos que no correspondan en su
autenticidad. • Registrar más de una cuenta correspondiente a una misma persona física o
jurídica, salvo excepciones pactadas previamente con HSA. • Borrar o revisar cualquier
material anunciado por otra persona o entidad. • Usar cualquier mecanismo, software o rutina
para impedir o intentar impedir el adecuado funcionamiento de los sitios web o cualquier
actividad que se esté realizando en los mismos. • Si posee una contraseña que le permite
acceder a un área no pública de este Sitio Web, se prohíbe revelar o compartir su contraseña
con terceros o usar su contraseña para cualquier propósito no autorizado, siendo el único
responsable del cuidado de su contraseña el creador de dicho Usuario. Kozaca S.A. tendrá el
derecho de rescindir inmediatamente la Cuenta de Usuario o bloquear el acceso a través de la
dirección IP en caso de cualquier conducta por parte del Usuario que Kozaca S.A., a su
exclusivo criterio, considere inaceptable y/o inapropiada, o en el eventual incumplimiento por
parte del Usuario de este Acuerdo o de normativas vigentes. 3- En cuanto al ingreso, la
registración y validación de los datos personales del Usuario. El Usuario de HSA para poder
utilizarla debe crear un usuario con sus datos personales fidedignos que lo identifican, como
son; nombre completo, DNI, fecha de nacimiento y dirección de correo electrónico. Además, debe
crear una contraseña que deberá custodiar y mantener bajo su responsabilidad exclusiva. La
verificación de la identidad del Usuario se realiza mediante el envío de una foto del DNI
dorso y frente del Usuario y una foto selfie del Usuario con su DNI en la mano. Luego, estos
datos son validados y se le acepta la registración al Usuario. Cada vez que el Usuario quiera
ingresar a su cuenta deberá ingresar los datos de su identificación y contraseña. El Usuario
presta expresa conformidad para la utilización de sus datos biométricos personales. La persona
registrada se compromete a brindar información correcta sobre su persona y a actualizarla cada
vez que sea necesario. Usted otorga su aceptación, anuencia y consentimiento para que sus
datos sean publicados en el perfil personal de profesional y/o institución y que sean
incluidos en bases de datos conforme a lo normado en la ley 25.326 y concordantes. Kozaca S.A.
no revelará los datos personales de aquellas personas registradas en los sitios web sin su
consentimiento previo, salvo situaciones en donde la ley lo exija, esto en consonancia con lo
enunciado en el párrafo anterior. Quien se registre en HSA se hará responsable de sus datos
personales, contraseña y de toda la información que almacene en su perfil, suya o de terceros.
Deberá comunicar inmediatamente a Kozaca S.A. sobre cualquier uso sin autorización de su
registro o contraseña. Kozaca S.A. no es responsable por el uso indebido por parte de terceros
u otros usuarios de información personal que figure en el sitio web. Cumpliendo con todos los
pasos indicados, se considerará firma electrónica vertida por el Usuario, todo ello en los
términos del artículo 3 y 5 de la ley 25.506. 4- Contenido de los sitios web Kozaca S.A.
... (contenido truncado for brevity, see original for full text) ...`,
    },
    privacy: {
      title: { prefix: 'Políticas de', highlight: 'Privacidad' },
      content: `1. Términos Generales Kozaca S.A. se encuentra interesada y
comprometida con el resguardo de la intimidad de sus usuarios y, por tal motivo, maximizará su
esfuerzo en su política de gestión para que todos los usuarios de sus aplicaciones Portal de
Turnos y Portal Paciente Mi Aliare (en adelante HSA), se encuentren protegidos, entendiendo
que el uso o visita al mismo será sin ninguna intención que menoscabe interés de tipo alguno.
La política de privacidad de Kozaca S.A., se aplica exclusivamente a la información ofrecida y
recibida por los usuarios de HSA de Kozaca S.A. y no a la ofrecida a otras o por otras
compañías, instituciones u organizaciones o aplicaciones con los que HSA contenga enlaces/
links y respecto de los cuales Kozaca S.A. no tiene control. En virtud de ello, Kozaca S.A. no
se responsabiliza por el actuar y/o proceder de las aplicaciones a los cuales se puede acceder
a través de HSA, por lo que recomendamos y sugerimos la lectura de la Política de Privacidad
de cada uno ellos. Mediante HSA, Kozaca S.A. puede recopilar determinada información, sobre la
que usted debe comprender plenamente nuestra política respecto al uso de la información que
obtenemos. Estos Términos Generales que revisten carácter declarativo, revelan qué información
recopilamos, cómo la usamos y de qué forma puede corregirse o cambiarse. Kozaca S.A. tiene
políticas de gestión, normas y procedimientos relativos a la seguridad física y lógica, las
que se encuentran en constante control, revisión, actualización y optimización, para dar
cumplimiento de las pautas legales y regulaciones normativas a nivel nacional que así lo
exigen para la protección de los datos personales. 2. Información General Nuestro sistema
podría recoger información automáticamente acerca de su conducta cuando navega por HSA, por
medio de «cookies». Estos son pequeños archivos de datos que algunas aplicaciones escriben en
el disco duro de su computadora en el momento en que usted ingresa para su visita. Un archivo
cookie puede contener tal información como la identificación del usuario que el sitio utiliza
para rastrear las páginas de Internet que usted ha visitado y/o ingresado. Es importante
destacar que, la única información personal que un cookie puede contener es información que
usted mismo suministra. Un cookie NO puede leer datos de su disco duro ni leer los archivos
cookies creados por otros sitios. Kozaca S.A. podría utilizar cookies para rastrear los
patrones de tráfico del usuario cuando navega por HSA. Si usted ha ajustado su navegador para
que le avise y/o indique antes de aceptar cookies, recibirá el mensaje indicador de
advertencia con cada cookie. Usted puede rehusar aceptar cookies, desactivándolos en su
navegador. Usted no necesita tener los cookies activados para usar HSA de Kozaca S.A. Si usted
rehúsa aceptar cookies, existe la posibilidad que no tenga acceso a ciertos servicios
brindados por HSA. 3. Información específica sobre usted En ciertos casos Kozaca S.A. tiene la
necesidad de acceder a datos personales suyos como, por ejemplo, su nombre completo, su DNI,
su fecha de nacimiento, su dirección de correo electrónico o su número telefónico (en
adelante, “Información Personal”). Kozaca S.A. necesita dicha información personal para poder
brindar los servicios que ofrece a través de HSA. En ciertos lugares de HSA, se le solicitará
Información Personal a los fines de facilitarle el uso de, o su participación en encuestas,
foros, suscripciones, envíos e inclusiones de contenido en nuestros boletines, registración en
suscripciones y/o con relación a cualesquiera otras actividades, servicios o recursos que
podamos suministrar u ofrecer en HSA. En estos casos, únicamente recopilaremos y/o
almacenaremos su Información Personal en caso que usted nos provea voluntariamente la misma y
mediante un proceso de aceptación de los Términos y Condiciones. Mediante esta aceptación, nos
autoriza a su uso para los fines indicados. Kozaca S.A. garantiza la confidencialidad de dicha
información, no permitiendo que terceros ajenos a la empresa accedan a la misma. Kozaca S.A.
limita el acceso a sus datos a empleados en los que creemos tengan razonables necesidades de
contar con dicha información para proveerle productos o servicios o a efectos de poder
realizar su trabajo. Kozaca S.A. no vende, alquila, intercambia ni presta información personal
de ninguna índole con ninguna persona o institución. 4. Finalidades de la recolección de
información personal Kozaca S.A. podría recoger información personal en HSA a los fines de:
autenticar al paciente o usuario, prestar un servicio al paciente o usuario, realizar
encuestas entre pacientes y materializar resultados, turnos, ofertas de servicios vinculados y
otros intercambios de información en HSA. La finalidad es conocer mejor al paciente o usuario
para poder brindarle con mayor eficacia, un servicio más personalizado y seguro. Ingresando su
Información Personal mediante cualquier canal dentro de HSA, acepta y avala que podamos
archivar su Información Personal y/o cualquier otro dato que haya ingresado por ésta vía, para
referencias futuras, acciones de marketing de Kozaca S.A. o bien descartar esa información en
forma parcial o total luego. 5. ¿Qué puede realizar Kozaca S.A. con esa información? Kozaca
S.A. no revelará y/o divulgará, ni compartirá ninguna información que pueda identificar a las
personas con ninguna otra institución u organización ajena a Kozaca S.A. sin el consentimiento
expreso del paciente o usuario, o cualquier otra persona que proporcione la información.
Kozaca S.A. puede hacer uso de la información para enviar al usuario información sobre HSA.
Los usuarios podrán elegir, si así lo desean, no recibir envíos en el futuro, solicitándolo
expresamente por carta o por correo electrónico a las direcciones que se le indiquen. Kozaca
S.A. puede utilizar la información personal para determinar la información que le corresponde
a nuestros pacientes o usuarios para su visualización desde HSA y obtener información
estadística y general del mercado. La información personal que usted le suministró a Kozaca
S.A. no será divulgada ni revelada a persona ajena de nuestra entidad. No compartimos
información sobre pacientes o usuarios individuales con ningún tercero u otras entidades.
Pero, tal como mencionamos con anterioridad, podemos compartir información estadística
agregada sobre el uso de HSA con nuestros usuarios de HSA para optimizar nuestro contenido y
adaptarlo a las necesidades de los usuarios. 6. Excepciones Sin perjuicio de cualquier otra
previsión en contrario en esta declaración, Kozaca S.A. podrá divulgar cierta información
privada sólo en caso de: • cumplir una exigencia legal y/o jurisdiccional • cumplir un
requerimiento de una autoridad gubernamental o reguladora; 7. Privacidad de los niños Como
consecuencia de que los menores de edad pueden no comprender correctamente la presente
Política de Privacidad y sus implicancias, ni decidir responsablemente sobre las opciones
disponibles para nuestros pacientes o usuarios, sugerimos a todos los padres o representantes
y/o adultos bajo cuya supervisión los menores accedan a HSA a participar activamente en las
actividades que el menor realice en Internet, a los servicios que utilicen los menores, a la
información a la que estos accedan y comuniquen, ya sea cuando dichos menores visiten HSA o
cualquier otro sitio de terceros. 8. Actualización de la Política de Privacidad de los Datos
de Kozaca S.A. Kozaca S.A. podrá rever, revisar y/o actualizar constantemente los aspectos
relativos a la Seguridad y Privacidad de HSA. En el momento que las mismas sean actualizadas,
le será informado por ésta vía, de forma tal que, usted siempre pueda saber qué información
recolectamos y cuál será el uso que le daremos a la misma. 9. Derecho de acceso, rectificación
y supresión de los datos registrados Kozaca S.A reconoce al Titular de los Datos Personales,
previa comprobación de su identidad, el derecho a requerir y a obtener información sobre sus
datos personales incluidos en sus registros, dentro de los diez (10) días hábiles desde el
requerimiento fehaciente que al efecto se realice, de conformidad con lo establecido en el
art. 14 de la Ley N° 25326 de Protección de Datos Personales. Kozaca S.A, también garantiza al
Titular de los Datos Personales el derecho a obtener la rectificación, actualización y/o la
supresión de los datos personales de los que sea titular, que estén incluidos en su banco de
datos y garantiza la rectificación, supresión o actualización de los mismos en el plazo máximo
de cinco días hábiles de recibido el reclamo del titular de los datos. En cumplimiento de la
disposición 10/2008 de la Dirección Nacional de Protección de Datos Personales se hace saber
que: El Titular de los Datos Personales tiene la facultad de ejercer el derecho de acceso a
los mismos en forma gratuita y en intervalos no inferiores a seis meses, salvo que acredite un
interés legítimo al efecto, conforme con lo establecido en el artículo 14, inciso 3 de la Ley
Nº 25.326. La DIRECCION NACIONAL DE PROTECCION DE DATOS PERSONALES, Órgano de Control de la
Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con
relación al incumplimiento de las normas sobre protección de datos personales. Los derechos de
acceso y rectificación de datos, se deberán ejercer a través de correo electrónico dirigido a
contacto@sanatorioaliare.com a solicitud del titular de los datos sin costo alguno. A tal fin
se deberá remitir un correo electrónico a la dirección mencionada, con el asunto “Informar”,
“Rectificar”, “Suprimir” y/o “Actualizar” según corresponda, juntamente con el objeto del
requerimiento. Kozaca S.A. podrá denegar el acceso, rectificación o la supresión de los datos
personales registrados únicamente por las causas previstas en la Ley de protección de datos
personales. 10. Aceptación de estos términos Al utilizar HSA, Ud. está manifestando conocer
nuestra Política de Privacidad y de los Términos y Condiciones de uso, por lo que damos por
aceptadas las mismas. Esta política de Privacidad fue actualizada por última vez el 29-01-2026`,
    },
  },
  footer: {
    administrativeHours: 'Lunes a Viernes de 8 a 20hs.<br />Sábados de 8 a 13hs.',
    emergencyText: 'Ingreso por Italia 1440. El Sanatorio Aliare cuenta con guardia activa las 24 hs, los 365 días del año.',
    mobile: {
      phone: 'Teléfono: +54 341 528 87 15',
      administrativeHours: 'Lunes a viernes de 5 a 20 hs.<br />Sábados de 5 a 13 hs.',
      emergencyText: 'Guardia General 24 hs.',
    },
  },
};
